/**
 * @name park
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMThoMTAiIC8+CiAgPHBhdGggZD0iTTEzLjI0OCA5Ljk5OEE0LjUgNC41IDAgMCAwIDExLjc1IDguNlY4YTEgMSAwIDAgMC03LjUgMCA0LjkgNC45IDAgMCAwIDIuMjUgOUg4IiAvPgogIDxwYXRoIGQ9Im0xNSAxNC0yIDYiIC8+CiAgPHBhdGggZD0ibTE5IDE0IDIgNiIgLz4KICA8cGF0aCBkPSJNMjEgMTRoLTgiIC8+CiAgPHBhdGggZD0iTTggMjB2LTUuOTIyYTIgMiAwIDAgMC0uNTg2LTEuNDE0TDYuNSAxMS43NSIgLz4KICA8cGF0aCBkPSJNOS4yMDUgMTIuNzk1IDggMTQiIC8+CiAgPGNpcmNsZSBjeD0iMTkiIGN5PSI2IiByPSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/park
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Park: string = `
<svg
  class="lucide lucide-park"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 18h10" />
  <path d="M13.248 9.998A4.5 4.5 0 0 0 11.75 8.6V8a1 1 0 0 0-7.5 0 4.9 4.9 0 0 0 2.25 9H8" />
  <path d="m15 14-2 6" />
  <path d="m19 14 2 6" />
  <path d="M21 14h-8" />
  <path d="M8 20v-5.922a2 2 0 0 0-.586-1.414L6.5 11.75" />
  <path d="M9.205 12.795 8 14" />
  <circle cx="19" cy="6" r="2" />
</svg>
`;

export default Park;
